import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
// import { title } from '@core/utils/filter'

import useJwt from '@/auth/jwt/useJwt'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useRewardVoucherList() {
  // Use toast
  const toast = useToast()

  const refIndicateListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    {
      key: 'rewardToken', label: 'Voucher', sortable: true,
    },
    {
      key: 'indicator', label: 'Nome Indicador', sortable: true,
    },
    {
      key: 'benefitIndicator.description', label: 'Recompensa',
    },
    {
      key: 'indicator.cpf', label: 'CPF', sortable: true,
    },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'actions', label: 'Baixar' },
  ]
  const perPage = ref(25)
  const totalRewards = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [5, 10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('rewardToken')
  const isSortDirDesc = ref(false)
  const stageFilter = ref(null)
  const filterDatesFilter = ref(null)
  const statusFilter = ref(null)
  const campaignsFilter = ref(null)
  const campaignsList = ref([])

  const isSuccessCheckoutVoucher = ref(false)
  const isInvalidCheckoutVoucher = ref(false)

  const dataMeta = computed(() => {
    const localItemsCount = refIndicateListTable.value ? refIndicateListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRewards.value,
    }
  })

  const refetchData = () => {
    refIndicateListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  const fetchRewardsVoucher = (ctx, callback) => {
    const payload = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      stage: stageFilter.value,
      status: statusFilter.value,
      campaign: campaignsFilter.value,
    }
    store
      .dispatch('app-rewards-voucher/fetchRewardsVoucher', payload)
      .then(response => {
        // const { rewards, total } = response.data
        const { rewards } = response.data.result || []
        const total = response.data.result ? response.data.result.qtyRegister : 0
        callback(rewards)
        totalRewards.value = total
      })
      .catch(error => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erro ao carregar a lista de cupons',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
        return error
      })
  }

  const handleCheckoutVoucher = voucherToken => {
    useJwt.validateCoupon(voucherToken)
      .then(response => {
        if (response.data.result.currentStatus.stage === 'Cancelado') {
          isInvalidCheckoutVoucher.value = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Cupom Cancelado',
              text: 'Recompensa não elegível para colaboradores.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
          return true
        }

        // seguir com o checkout
        store.dispatch('app-rewards-voucher/handleCheckoutVoucher',
          voucherToken)
          .then(() => {
            isSuccessCheckoutVoucher.value = true
            toast({
              component: ToastificationContent,
              props: {
                title: 'Sucesso!',
                text: 'Status de recompensa atualizado com sucesso!',
                icon: 'AlertTriangleIcon',
                variant: 'success',
              },
            })
          })
          .catch(() => {
            toast({
              component: ToastificationContent,
              props: {
                title: 'Ocorreu um erro',
                text: 'Tente novamente',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          })
          .finally(() => refetchData())
        // checkout finalizado

        // fim do validate
        return true
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Ocorreu um erro',
            text: 'Tente novamente',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
      .finally(() => refetchData())
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveIndicateStageIcon = stage => {
    if (stage === 'Em Andamento') return 'ClockIcon'
    if (stage === 'Cancelado') return 'XIcon'
    if (stage === 'Concluído') return 'CheckIcon'
    return 'ClockIcon'
  }
  const resolveIndicateStageVariant = stage => {
    if (stage === 'Em Andamento') return 'dark'
    if (stage === 'Cancelado') return 'danger'
    if (stage === 'Concluído') return 'success'
    return 'dark'
  }

  const resolveIndicateStatusVariant = status => {
    if (status === 'Recebido') return 'light-primary'
    if (status === 'Disponivel') return 'light-success'
    if (status === 'Negado') return 'light-danger'
    return 'light-dark'
  }

  return {
    fetchRewardsVoucher,
    tableColumns,
    perPage,
    currentPage,
    totalRewards,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refIndicateListTable,

    resolveIndicateStageIcon,
    resolveIndicateStageVariant,
    resolveIndicateStatusVariant,
    refetchData,
    handleCheckoutVoucher,

    // Extra Filters
    statusFilter,
    stageFilter,
    campaignsFilter,
    filterDatesFilter,

    campaignsList,
    isSuccessCheckoutVoucher,
    isInvalidCheckoutVoucher,
  }
}
